// extracted by mini-css-extract-plugin
export default {"serving":"Serving_serving--IPD"};